import { getLocale } from "../runtime";

const sv_userdescription = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Utforska olika användargrupper på Happy Green`
};

const userdescription = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_userdescription(inputs)
	return "userDescription";
};

export { userdescription as "userDescription" };